<template>
  <div class="positions-slider rows justify-space-between align-items-center pt-30">
    <button
        @click="toggleSimulation"
        class="transparent pr-5 font-size-20">
      <i :class="isSimulationRunning ? 'bi bi-pause-circle' : 'bi bi-play-circle'"></i>
    </button>
    <SimulationSpeedSelect
        :model-value="simulationSpeed"
        :options="simulationSpeedOptions"
        @update:modelValue="onSimulationSpeedChange"
    />
    <button @click="onPreviousArrowClick" class="transparent pr-5 font-size-20">
      <i class="bi bi-arrow-left-circle"></i>
    </button>
    <button @click="onNextArrowClick" class="transparent pr-15 font-size-20">
      <i class="bi bi-arrow-right-circle"></i>
    </button>
    <VueSlider class="positions-slider-input width-100p pr-15" v-model="selectedPosition"
               :data="sliderPositions" data-label="label" data-value="value" tooltip="always" :marks="[]"
               ref="slider"
               @change="(value) => sliderChange(value)" />
  </div>
</template>

<script>
import VueSlider from "vue-slider-component";
import SimulationSpeedSelect from "@/components/pages/partials/SimulationSpeedSelect.vue";

export default {
  name: 'PositionsSlider',
  components: {
    VueSlider,
    SimulationSpeedSelect,
  },
  props: {
    modelValue: {
      type: [Number, String],
      default: null,
    },
    sliderPositions: {
      type: Array,
      required: true,
    },
  },
  emits: ['update:modelValue', 'change'],
  data() {
    return {
      simulationSpeed: 1,
      simulationSpeedOptions: [1, 2, 3, 5, 10, 20, 50],
      simulationIntervalId: null,
    };
  },
  computed: {
    selectedPosition: {
      get() {
        return this.modelValue;
      },
      set(value) {
        this.$emit('update:modelValue', value);
      },
    },
    isSimulationRunning() {
      return this.simulationIntervalId !== null;
    },
  },
  beforeUnmount() {
    this.stopSimulation();
  },
  methods: {
    onPreviousArrowClick() {
      this.stopSimulation();
      this.selectPreviousPositionOfSelectedTrip();
    },
    onNextArrowClick() {
      this.stopSimulation();
      this.selectNextPositionOfSelectedTrip();
    },
    toggleSimulation() {
      if (this.isSimulationRunning) {
        this.stopSimulation();
        return;
      }

      this.startSimulation();
    },
    onSimulationSpeedChange(newSpeed) {
      this.simulationSpeed = newSpeed;
      if (!this.isSimulationRunning) {
        return;
      }

      this.stopSimulation();
      this.startSimulation();
    },
    startSimulation() {
      const curSlideIndex = this.getSelectedPositionIndex();
      const nextSlideIndex = curSlideIndex + 1;
      if (this.isSimulationRunning || nextSlideIndex >= this.sliderPositions.length ||
          this.sliderPositions.length === 0) {
        return;
      }

      const delay = Math.max(1, Math.round(1000 / this.simulationSpeed));
      this.simulationIntervalId = setInterval(() => {
        const curSlideIndex = this.getSelectedPositionIndex();
        const nextSlideIndex = curSlideIndex + 1;

        if (nextSlideIndex >= this.sliderPositions.length) {
          this.stopSimulation();
          return;
        }

        const selectedPosition = this.sliderPositions[nextSlideIndex].value;
        this.selectedPosition = selectedPosition;
        this.sliderChange(selectedPosition, false);
      }, delay);
    },
    stopSimulation() {
      if (this.simulationIntervalId === null) {
        return;
      }

      clearInterval(this.simulationIntervalId);
      this.simulationIntervalId = null;
    },
    selectPreviousPositionOfSelectedTrip() {
      const curSlideIndex = this.getSelectedPositionIndex();
      const prevSlideIndex = curSlideIndex - 1;
      if (prevSlideIndex < 0) {
        return;
      }

      const selectedPosition = this.sliderPositions[prevSlideIndex].value;
      this.selectedPosition = selectedPosition;
      setTimeout(() => this.sliderChange(selectedPosition));
    },
    selectNextPositionOfSelectedTrip() {
      const curSlideIndex = this.getSelectedPositionIndex();
      const nextSlideIndex = curSlideIndex + 1;
      if (nextSlideIndex >= this.sliderPositions.length) {
        return;
      }

      const selectedPosition = this.sliderPositions[nextSlideIndex].value;
      this.selectedPosition = selectedPosition;
      setTimeout(() => this.sliderChange(selectedPosition));
    },
    sliderChange(value, shouldStopSimulation = true) {
      if (shouldStopSimulation) {
        this.stopSimulation();
      }

      this.$emit('change', value, this.sliderPositions[this.getSelectedPositionIndex(value)]);
    },
    getSelectedPositionIndex(value = this.selectedPosition) {
      const index = this.sliderPositions.findIndex(position => position.value === value);
      if (index !== -1) {
        return index;
      }

      return this.$refs.slider?.getIndex?.() ?? -1;
    },
  },
};
</script>

<style scoped>
.positions-slider-input {
  width: 100% !important;
}
</style>
